import clsx from 'clsx';
import { Maybe, isJust } from 'maybeasy';
import { when } from '@execonline-inc/maybe-adapter';
import { ProductLicenseResource } from '../../../../../Types';
import { EitherLearningCollectionStore } from '../../../../../Types';
import { fromArrayMaybe } from 'nonempty-list';

export const selectProductLicense = (
  selectedProductLicense: Maybe<ProductLicenseResource>,
  activeProductLicense: ProductLicenseResource,
): Maybe<{}> =>
  selectedProductLicense.andThen((selectedProductLicense) =>
    when(selectedProductLicense.payload.id == activeProductLicense.payload.id, {}),
  );

export const productLicenseCardStyle = (
  selectedProductLicense: Maybe<ProductLicenseResource>,
  activeProductLicense: ProductLicenseResource,
) =>
  clsx(
    'flex flex-col cursor-pointer items-start rounded-md bg-white p-6 my-2 drop-shadow',
    activeProductLicense.payload.productType === 'Add-on'
      ? 'order-last cursor-auto border border-solid border-teal-400 bg-teal-500 bg-opacity-50'
      : '',
    selectProductLicense(selectedProductLicense, activeProductLicense)
      .map(() => 'border border-solid border-teal-400 bg-teal-500 bg-opacity-50')
      .getOrElseValue(''),
  );

export const checkedStatus = (
  selectedProductLicense: Maybe<ProductLicenseResource>,
  activeProductLicense: ProductLicenseResource,
) => isJust(selectProductLicense(selectedProductLicense, activeProductLicense));

export const filterOnlySelectedInactiveLicense = (
  store: EitherLearningCollectionStore,
  inactiveLicenses: ProductLicenseResource[],
) =>
  store.selectedProductLicense.andThen((productLicense) =>
    fromArrayMaybe(
      inactiveLicenses.filter((license) => license.payload.id === productLicense.payload.id),
    ),
  );
